module.exports = __webpack_public_path__ + "icons/original/small/small-d5.ae2144db1de56afe0541c89db7a31463.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-d5.png
// module id = d6hy
// module chunks = app